import { Schema as S } from "effect";
import { defineMessageUnion } from "foldkit/message";

import {
	editEntry,
	getEntry,
	getEntryHistory,
} from "../../api/commands/entries";
import { ApiError } from "../../api/errors";
import { ValueType } from "../../api/schemas/attributeSchema";
import { Entry } from "../../api/schemas/entries";
import { RecordSummary } from "../../api/schemas/records";
import * as Editor from "../../widgets/editor";
import { DownloadResult } from "../../widgets/fileDownload";
import * as Tags from "../../widgets/tags";
import { Tab } from "./model";

export const Message = defineMessageUnion({
	// Completions carry the entry they were issued for: a late result for the
	// previous entry must not land on the page after the route changed.
	CompletedFetchEntry: {
		knotId: S.String,
		asOf: S.Option(S.String),
		generation: S.Number,
		result: getEntry.Result,
	},
	CompletedFetchLinkedRecords: {
		knotId: S.String,
		generation: S.Number,
		result: S.Result(S.Array(RecordSummary), ApiError),
	},
	ClickedBack: {},
	CompletedNavigate: {},
	SelectedTab: { tab: Tab },
	CompletedFetchHistory: {
		knotId: S.String,
		cursor: S.Number,
		generation: S.Number,
		result: getEntryHistory.Result,
	},
	ClickedLoadMoreHistory: {},
	ToggledHistoryVersion: { version: S.Number },
	ClickedViewAt: { validFrom: S.String },
	ClickedEdit: {},
	ClickedCancelEdit: {},
	ChangedTitle: { value: S.String },
	/** UTC ISO instant from the datetime-local input (converted in the view); empty leaves the timestamp alone. */
	ChangedOccurredOn: { value: S.String },
	GotEditorMessage: { message: Editor.Message },
	ClickedEditorAction: { action: Editor.Action },
	CompletedEditorAction: {},
	GotTagsMessage: { message: Tags.Message },
	ClickedRemoveTag: { tag: S.String },
	ClickedAddAttribute: {},
	ChangedAttributeKey: { index: S.Number, value: S.String },
	ChangedAttributeType: { index: S.Number, value: ValueType },
	ChangedAttributeValue: { index: S.Number, value: S.String },
	ClickedRemoveAttribute: { index: S.Number },
	ClickedSave: {},
	/** `editing` says whether this was the Save (true) or a task toggle (false). */
	CompletedEditEntry: {
		knotId: S.String,
		generation: S.Number,
		editing: S.Boolean,
		/** The entry as sent; on success it replaces the loaded one (v1 `setQueryData`). */
		entry: Entry,
		result: editEntry.Result,
	},
	ClickedToggleTask: { taskId: S.String },
	ToggledAdditionalData: {},
	ClickedDownload: {},
	CompletedDownload: { generation: S.Number, result: DownloadResult },
});
export type Message = typeof Message.Type;
